<template>
    <path d="M12 1.4c-1.38 0-2.66.74-3.35 1.93L.87 16.8a3.86 3.86 0 0 0 3.34 5.79h15.57a3.86 3.86 0 0 0 3.2-6.01L15.35 3.33A3.86 3.86 0 0 0 12 1.4zm0 3.77a1.7 1.7 0 0 1 1.7 1.7 1.7 1.7 0 0 1 0 .02l-.01.13-.82 7.12c-.05.52-.4.84-.87.84-.48 0-.82-.33-.87-.84l-.82-7.12v-.03a1.7 1.7 0 0 1 0-.02v-.08a1.7 1.7 0 0 1 0-.02A1.7 1.7 0 0 1 12 5.17zm0 11.06c.95 0 1.65.7 1.65 1.6v.05c0 .9-.7 1.6-1.65 1.6a1.6 1.6 0 0 1-1.65-1.6v-.04c0-.91.7-1.61 1.65-1.61z"/>
</template>

<script>
    export default {
        name: 'warning',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Warning.vue